import {
  PHOTOGRAPHERS_TAXONOMY_KEY,
  SearchableVendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorWordSingular } from '@zola-helpers/client/dist/es/marketplace/vendorWords';
import { CheckboxList } from '@zola/zola-ui/src/components/Form/CheckboxList';

import { FieldArray } from 'react-final-form-arrays';

import { REQUIRED } from '~/components/common/form/commonValidations';
import { FormDropdown } from '~/components/common/form/FinalForm/Inputs';

import { GeneralQuestions } from './GeneralQuestions';

const PHOTOGRAPHER_PERSONALITY = [
  {
    value: 'personality-authoritative',
    label: 'Decisive',
  },
  {
    value: 'personality-lively',
    label: 'Lively',
  },
  {
    value: 'personality-easygoing',
    label: 'Easygoing',
  },
  {
    value: 'personality-reserved',
    label: 'Serene',
  },
];

const PHOTOGRAPHY_STYLE = [
  {
    value: 'photography-style-photojournalistic',
    label: 'Photojournalistic',
  },
  {
    value: 'photography-style-editorial',
    label: 'Editorial',
  },
  {
    value: 'photography-style-classic',
    label: 'Classic',
  },
  {
    value: 'photography-style-fine-art',
    label: 'Fine Art',
  },
];

interface PhotographerQuestionsProps {
  category: SearchableVendorTaxonomyKey;
}

export const PhotographerQuestions = ({ category }: PhotographerQuestionsProps): JSX.Element => {
  const categoryName = getVendorWordSingular(category);
  return (
    <div>
      <GeneralQuestions />
      <fieldset className="mt-primary">
        <legend>{categoryName} Personality</legend>
        <FieldArray
          options={PHOTOGRAPHER_PERSONALITY}
          name="optionFacetKeys"
          id="photographerPersonality"
          validate={REQUIRED}
        >
          {({ fields, meta }) => (
            <CheckboxList fields={fields} meta={meta} options={PHOTOGRAPHER_PERSONALITY} />
          )}
        </FieldArray>
      </fieldset>
      {category === PHOTOGRAPHERS_TAXONOMY_KEY && (
        <fieldset className="mt-primary">
          <legend>Photography Style</legend>
          <FormDropdown
            options={PHOTOGRAPHY_STYLE}
            name="photographyStyle"
            id="photographyStyle"
            placeholder="Select"
            validate={REQUIRED}
          />
        </fieldset>
      )}
    </div>
  );
};
